import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { DocumentFilterType, DocumentTypesService } from 'src/app/modules/shared/services/document-types/document-types.service';
import { ToasterService } from 'src/app/modules/shared/services/toaster/toaster.service';

@Component({
  selector: 'file-filter',
  templateUrl: './file-filter.component.html',
  styleUrls: ['./file-filter.component.scss']
})
export class FileFilterComponent implements OnInit {
  /** The list of all possible document types grouped by category */
  categorized_types: Map<string, DocumentFilterType[]> = new Map();
  /** The list of document types that match the search query */
  filtered_types: Map<string, DocumentFilterType[]> = new Map();
  /** The search input from the person trying to filter their filter options */
  search_document_type: string = '';

  @Input() active_filter_types: number[] | undefined = undefined;
  @Output() filter_selelected_type: EventEmitter<number> = new EventEmitter<number>();
  @Output() filter_cleared_type: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private documentTypesService: DocumentTypesService,
    private Toaster: ToasterService
  ) {}

  public clearTypeFilter() {
    this.search_document_type = '';
    this.filter_cleared_type.emit(undefined);
  }

  public isActiveType(type_id: number): boolean {
    return this.active_filter_types?.includes(type_id) ?? false;
  }

  public refineTypeSelection() {
    if (!this.search_document_type) {
      this.filtered_types = new Map(this.categorized_types);
      return;
    }

    const searchTerm = this.search_document_type.toLowerCase();
    this.filtered_types = new Map();

    this.categorized_types.forEach((types, category) => {
      const filteredTypes = types.filter(type => 
        type.TYPE_NAME.toLowerCase().includes(searchTerm)
      );
      if (filteredTypes.length > 0) {
        this.filtered_types.set(category, filteredTypes);
      }
    });
  }

  public async getDocumentTypes() {
    try {
      const types = await this.documentTypesService.get(); // Change to get() instead of getGrouped()
      
      // Group types by category
      this.categorized_types = types.reduce((acc, type) => {
        const category = type.CATEGORY_NAME.replace(/_/g, ' ');
        if (!acc.has(category)) {
          acc.set(category, []);
        }
        acc.get(category)?.push(type);
        return acc;
      }, new Map<string, DocumentFilterType[]>());

      this.filtered_types = new Map(this.categorized_types);
    } catch (error: any) {
      this.Toaster.warning(`Error fetching document type filter options: ${error?.message ?? error}`, 4000);
      console.error('Error fetching filter options "type":', error);
    }
  }

  public onDocumentTypeSelect(type_id: number) {
    this.filter_selelected_type.emit(type_id);
  }

  ngOnInit(): void {
    this.getDocumentTypes();
  }
}
